import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { ExposureViewMode, IExposureDashboardStore } from './exposureDashboard.interface';

export const EXPOSURE_POLLING_INTERVAL = 5000;

export const EXPOSURE_VIEW_MODE_DEFAULT: ExposureViewMode = 'flat';

/** Profile setting that remembers the flat/tree choice (LB-4992). */
export const EXPOSURE_VIEW_MODE_SETTING_KEY = `${UserSettingsPage.DashboardsExposure}.viewMode`;

export const exposureDashboardInitialState: IExposureDashboardStore = {
  filter: {},
};
